module.exports = __webpack_public_path__ + "cfc02f2fed915b1cda54881ac7a9dd80.svg";